import { render, staticRenderFns } from "./lamsRegLegalConsultInfo.vue?vue&type=template&id=2f051165&scoped=true&"
import script from "./lamsRegLegalConsultInfo.vue?vue&type=script&lang=js&"
export * from "./lamsRegLegalConsultInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f051165",
  null
  
)

export default component.exports